import React, { useState } from "react";
import { MdRefresh } from "react-icons/md";
import UserService from "../../services/auth/UserService";

function RefreshButton({ id, setUserData, userData, index }) {
  const [loading, setLoading] = useState(false);

  return (
    <div
      onClick={() => {
        setLoading(true);
        UserService.refreshUser(id)
          .then((response) => {
            let data = [...userData];
            let user = { ...userData[index] };
            user = response.data;
            user.refreshId = user.id;
            data[index] = user;
            setUserData(data);
            console.log(`Refreshed user ${id}: `, response.data);
            setLoading(false);
          })
          .catch((e) => {
            console.log(`Error refreshing user ${id}: ${e}`);
            setLoading(false);
          });
      }}
    >
      <div className={`loading-icon ${loading ? "rotating" : ""}`}>
        <MdRefresh />
      </div>
    </div>
  );
}

export default RefreshButton;
